import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment/moment';
import { ToastyService, ToastOptions, ToastData } from 'ng2-toasty';
import { AlertComponent } from './../alert/alert.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { IOption } from 'ng-select';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.scss']
})
export class BranchComponent implements OnInit {
  deleteId: any;
  ToolTip = 'Delete is not allowed since it is used in contract registration page';
  msgtext: string = '';
  loading: boolean = true;
  isEmiratesLoaded: boolean = false;
  isBranchListLoaded: boolean = false;
  isDeleteAvailabilityLoaded: boolean = false;
  myFormsOptionsEmirates: Array<IOption> = [];
  Emirateplaceholder: any = 'SELECT A EMIRATES';
  branchvalue: string = '';
  isValid: boolean = false;
  inputvalidate: boolean = false;
  Listbranchdetails: any[] = [];
  editobjid: any;
  orgId: number;
  userId: number;
  alerttxt: any;
  btnName = 'Submit';
  p: number = 1;
  startingCount: number = 0;
  endingCount: number = 0;
  emirateserr: boolean = false;
  ListEmiratesdetails: any[] = [];
  emirates: any;
  @ViewChild('add') add: Popup;
  @ViewChild('update') update: Popup;
  @ViewChild('Askdelete') Askdelete: Popup;
  @ViewChild('delete') delete: Popup;
  latitude: any;
  longitude: any;
  userSettings = {};
  location: any;
  lat: any;
  lng: any;
  lat1: number;
  lng1: number;
  expanded: boolean = false;
  zoomIn = 12;
  branchalias: any;
  branchaliaserr: boolean = false;
  search: any;

  constructor(
    private dialogservice: DialogService,
    private route: ActivatedRoute,
    private http: Http,
    private toastyservice: ToastyService
  ) {}

  ngOnInit() {
    if (this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null) {
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId = this.route.params['value'].orgId;
      this.userId = this.route.params['value'].userId;
      console.log('OrgId ' + this.orgId);
      console.log('UserId ' + this.userId);
    }

    this.loading = true;
    this.isEmiratesLoaded = false;
    this.isBranchListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    this.getemiratesdetails();
    this.getbranchdetails();
  }

  updateLoadingState() {
    this.loading = !(this.isEmiratesLoaded && this.isBranchListLoaded && this.isDeleteAvailabilityLoaded);
  }

  normalizeBranchLocation(value: any): string {
    return String(value || '').trim().toLowerCase();
  }

  sanitizeBranchAlias(value: any): string {
    return String(value || '').trim();
  }

  showDuplicateDialog(message: string) {
    this.dialogservice.addDialog(AlertComponent, { title: 'DUPLICATE BRANCH', message: message });
  }

  toggle() {
    this.expanded = !this.expanded;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  showAlertforAddingData() {
    this.dialogservice.addDialog(AlertComponent, { title: 'ADD BRANCH', message: 'The Data is added successfully' });
  }

  showAlertforUpdatingData() {
    this.dialogservice.addDialog(AlertComponent, { title: 'UPDATE BRANCH', message: 'The Data is updated successfully' });
  }

  showAlertforDeletingData() {
    this.dialogservice.addDialog(AlertComponent, { title: 'DELETE BRANCH', message: 'The Data is Deleted successfully' });
  }

  mapClicked(Event) {
    this.latitude = Event.coords.lat;
    this.longitude = Event.coords.lng;

    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + Event.coords.lat + ',' + Event.coords.lng + '%20&key=AIzaSyCTK07AppZAiE0nxsrCtgjK37aGiwv-dqc').subscribe(res => {
      let response = res.json();
      this.location = response.results[0].formatted_address;
      for (let m = 0; m < response.results[0].address_components.length; m++) {
        for (let t = 0; t < response.results[0].address_components[m].types.length; t++) {
          if (response.results[0].address_components[m].types[t] == 'sublocality' || response.results[0].address_components[m].types[t] == 'sublocality_level_1' || response.results[0].address_components[m].types[t] == 'locality') {
            this.branchalias = response.results[0].address_components[m].short_name;
            break;
          } else if (response.results[0].address_components[m].types[t] == 'administrative_area_level_1') {
            this.branchalias = response.results[0].address_components[m].short_name;
            break;
          } else if (response.results[0].address_components[m].types[t] == 'administrative_area_level_2') {
            this.branchalias = response.results[0].address_components[m].short_name;
            break;
          }
        }
      }
      this.validate(this.location);
      this.branchAlias();
    });
  }

  chooseEmirates(value) {
    let num = parseInt(value, 10);
    if (this.emirates == '' || this.emirates == undefined || this.emirates == null) {
      this.emirateserr = true;
    } else {
      this.expanded = true;
      this.emirateserr = false;
      for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
        if (this.ListEmiratesdetails[i]._id == num) {
          this.lat = parseFloat(this.ListEmiratesdetails[i].latitude);
          this.lng = parseFloat(this.ListEmiratesdetails[i].longitude);
        }
      }
    }
  }

  branchAlias() {
    if (this.sanitizeBranchAlias(this.branchalias) === '') {
      this.branchaliaserr = true;
    } else {
      this.branchaliaserr = false;
    }
  }

  addOk() {
    this.add.hide();
  }

  updateOk() {
    this.update.hide();
  }

  deleteOk() {
    this.delete.hide();
  }

  getbranchdetails() {
    this.loading = true;
    this.isBranchListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    let branchObj = {
      'orgId': this.orgId
    };
    return this.http.post('/api/getbranchdetails', branchObj).subscribe(res => {
      let responseBranch = res.json();
      this.Listbranchdetails = (responseBranch || []).map((branchdetails: any) => ({
        ...branchdetails,
        status: false,
        deleteBlockedReason: ''
      }));
      if (this.Listbranchdetails.length > 0) {
        console.log('Listbranchdetails', this.Listbranchdetails);
        this.getCount();
        this.isBranchListLoaded = true;
        this.loadDeleteAvailability();
      } else {
        this.isBranchListLoaded = true;
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      }
    }, err => {
      this.isBranchListLoaded = true;
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.alerttxt = 'Unable to load the branch value';
        this.getWarningFunction(this.alerttxt);
      }
    });
  }

  getemiratesdetails() {
    let emiratesObj = {
      'orgId': this.orgId
    };
    return this.http.post('/api/getEmiratesdetails', emiratesObj).subscribe(res => {
      let responseEmirates = res.json();
      this.ListEmiratesdetails = responseEmirates.result_data || [];
      this.LoadEmiratesDropDown();
      this.isEmiratesLoaded = true;
      this.updateLoadingState();
    }, err => {
      this.isEmiratesLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.alerttxt = 'Unable to load the Emirates value';
        this.getWarningFunction(this.alerttxt);
      }
    });
  }

  loadDeleteAvailability() {
    let branchIds: any[] = [];

    for (let i = 0; i < this.Listbranchdetails.length; i++) {
      this.Listbranchdetails[i].status = false;
      this.Listbranchdetails[i].deleteBlockedReason = '';
      branchIds.push(this.Listbranchdetails[i]._id);
    }

    return this.http.post('/api/getBranchDeleteAvailability', {
      'ids': branchIds,
      'orgId': this.orgId
    }).subscribe(res => {
      let availabilityResponse = res.json().availability || {};

      for (let i = 0; i < this.Listbranchdetails.length; i++) {
        if (availabilityResponse[String(this.Listbranchdetails[i]._id)] && availabilityResponse[String(this.Listbranchdetails[i]._id)].canDelete === false) {
          this.Listbranchdetails[i].status = true;
          this.Listbranchdetails[i].deleteBlockedReason = availabilityResponse[String(this.Listbranchdetails[i]._id)].reason || this.ToolTip;
        }
      }

      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
    }, err => {
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.msgtext = 'Unable to validate delete availability';
        this.getWarningFunction(this.msgtext);
      }
    });
  }

  LoadEmiratesDropDown() {
    let pusharr = [];
    for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
      pusharr.push({ 'value': this.ListEmiratesdetails[i]._id.toString(), 'label': this.ListEmiratesdetails[i].emirates.toUpperCase() });
    }
    this.myFormsOptionsEmirates = pusharr;
  }

  getCount() {
    if (this.p < Math.ceil(this.Listbranchdetails.length / 10)) {
      this.startingCount = (this.p - 1) * 10;
      if (this.startingCount == 0) {
        this.startingCount = 1;
      }
      this.endingCount = this.p * 10;
    } else if (this.p == Math.ceil(this.Listbranchdetails.length / 10)) {
      let count = this.Listbranchdetails.length % 10;
      this.startingCount = (this.p - 1) * 10;
      this.endingCount = this.startingCount + count;
      if (this.startingCount == 0) {
        this.startingCount = 1;
        this.endingCount = count;
      }
    }
  }

  Editing(index, objectId) {
    this.empty();
    this.expanded = true;
    this.editobjid = objectId;
    this.btnName = 'Update';
    this.zoomIn = 12;
    this.LoadEmiratesDropDown();

    for (let j = 0; j < this.Listbranchdetails.length; j++) {
      if (this.Listbranchdetails[j]._id == objectId) {
        this.emirates = this.Listbranchdetails[j].emirateId.toString();
        for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
          if (this.emirates == this.ListEmiratesdetails[i]._id) {
            this.Emirateplaceholder = this.ListEmiratesdetails[i].emirates.toUpperCase();
          }
        }
        this.location = this.Listbranchdetails[j].branchAddress.toUpperCase();
        this.lat1 = parseFloat(this.Listbranchdetails[j].latitude);
        this.lng1 = parseFloat(this.Listbranchdetails[j].longitude);
        this.lat = parseFloat(this.Listbranchdetails[j].latitude);
        this.lng = parseFloat(this.Listbranchdetails[j].longitude);
        this.latitude = this.Listbranchdetails[j].latitude;
        this.longitude = this.Listbranchdetails[j].longitude;
        this.branchalias = this.Listbranchdetails[j].branchAlias;
        this.isValid = true;
      }
    }
  }

  reset() {
    this.empty();
  }

  empty() {
    this.location = '';
    this.emirates = '';
    this.editobjid = '';
    this.inputvalidate = false;
    this.btnName = 'Submit';
    this.isValid = false;
    this.branchalias = '';
    this.Emirateplaceholder = 'SELECT A DISTRICT';
    this.emirateserr = false;
    this.branchaliaserr = false;
    this.expanded = false;
    this.lat1 = 25.190519127063453;
    this.lng1 = 55.393190206959844;
    this.latitude = null;
    this.longitude = null;
    this.LoadEmiratesDropDown();
  }

  validate(val) {
    if (this.normalizeBranchLocation(this.location) === '') {
      this.inputvalidate = true;
      this.isValid = false;
    } else {
      this.inputvalidate = false;
      this.isValid = true;
    }
  }

  onsubmit() {
    this.LoadEmiratesDropDown();
    this.loading = true;
    this.validate(this.location);
    this.branchAlias();
    let branchAddress = this.normalizeBranchLocation(this.location);
    let branchAlias = this.sanitizeBranchAlias(this.branchalias);
    if (this.emirates == undefined || this.emirates == '' || this.emirates == null) {
      this.emirateserr = true;
      this.loading = false;
    } else if (branchAddress === '') {
      this.inputvalidate = true;
      this.loading = false;
    } else if (branchAlias === '') {
      this.branchaliaserr = true;
      this.loading = false;
    } else {
      let branchLatitude = this.latitude != undefined && this.latitude != null ? this.latitude : this.lat1;
      let branchLongitude = this.longitude != undefined && this.longitude != null ? this.longitude : this.lng1;
      if (this.editobjid == null || this.editobjid == undefined || this.editobjid == '') {
        let reqbranchobj = {
          'branch': branchAddress,
          'branchalias': branchAlias,
          'orgId': this.orgId,
          'emirate': this.emirates,
          'latitude': branchLatitude,
          'longitude': branchLongitude,
          'created_By': this.userId,
          'created_Date': moment.utc().format('YYYY:MM:DD h:mm:ss')
        };

        return this.http.post('/api/addbranch', reqbranchobj).subscribe(res => {
          let branchresponse = res.json();
          if (branchresponse.message == 'This Branch Already Exists') {
            this.loading = false;
            this.showDuplicateDialog('This Branch Already Exists');
          } else {
            this.empty();
            this.getbranchdetails();
            this.showAlertforAddingData();
          }
        }, err => {
          this.loading = false;
          if (err.status != 200) {
            this.alerttxt = 'Unable to add the branch value';
            this.getWarningFunction(this.alerttxt);
          }
        });
      } else {
        let reqbranchobj = {
          'branch': branchAddress,
          'branchalias': branchAlias,
          'orgId': this.orgId,
          'emirate': this.emirates,
          'latitude': branchLatitude,
          'longitude': branchLongitude,
          'updated_By': this.userId,
          'updated_Date': moment.utc().format('YYYY:MM:DD h:mm:ss'),
          'objectId': this.editobjid
        };
        return this.http.post('/api/updateBranchdetails', reqbranchobj).subscribe(res => {
          let branchresponse = res.json();
          if (branchresponse.message == 'This Branch Already Exist' || branchresponse.message == 'This Branch Already Exists') {
            this.loading = false;
            this.showDuplicateDialog('This Branch Already Exists');
          } else {
            this.empty();
            this.getbranchdetails();
            this.showAlertforUpdatingData();
          }
        }, err => {
          this.loading = false;
          if (err.status != 200) {
            this.alerttxt = 'Unable to update the branch Value';
            this.getWarningFunction(this.alerttxt);
          }
        });
      }
    }
  }

  getWarningFunction(err) {
    var toastOptions: ToastOptions = {
      title: 'Branch',
      msg: err,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast: ToastData) => {
      },
      onRemove: function(toast: ToastData) {
      }
    };
    this.toastyservice.warning(toastOptions);
  }

  getSuccessFunction(success) {
    var toastoptions: ToastOptions = {
      title: 'Branch',
      msg: success,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast: ToastData) => {
      },
      onRemove: function(toast: ToastData) {
      }
    };
    this.toastyservice.success(toastoptions);
  }

  Delete(index, deleteId) {
    if (this.Listbranchdetails[index] && this.Listbranchdetails[index].status === true) {
      this.msgtext = this.Listbranchdetails[index].deleteBlockedReason || this.ToolTip;
      this.getWarningFunction(this.msgtext);
      return false;
    }

    this.reset();
    this.deleteId = deleteId;
    this.Askdelete.options = {
      showButtons: false,
      color: '#4180ab',
      header: 'Delete Branch'
    };
    this.Askdelete.show(this.Askdelete.options);
  }

  No() {
    this.Askdelete.hide();
  }

  Yes() {
    this.loading = true;
    this.Askdelete.hide();

    let reqMakeObj = {
      'deleteId': this.deleteId,
      'orgId': this.orgId
    };
    return this.http.post('/api/deleteBranchDetails', reqMakeObj).subscribe(res => {
      let branchResponse = res.json();
      if (branchResponse && branchResponse.canDelete === false) {
        this.msgtext = branchResponse.reason || this.ToolTip;
        this.getWarningFunction(this.msgtext);
        this.deleteId = '';
        this.getbranchdetails();
        return;
      }

      this.showAlertforDeletingData();
      this.deleteId = '';
      this.getbranchdetails();
    }, err => {
      this.loading = false;
      this.msgtext = 'Unable to delete the Value in mysql';
      this.getWarningFunction(this.msgtext);
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/branch/branch.component.ts